import { render } from "./VerificationTool.vue?vue&type=template&id=3619dc54"
import script from "./VerificationTool.vue?vue&type=script&lang=js"
export * from "./VerificationTool.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__